import { Injectable } from '@angular/core';
import { AppSettings } from '../../proyect.conf';
import { HttpClient } from '@angular/common/http';
import { AutenticacionService } from './autenticacion.service';
import { map } from 'rxjs/operators';
import { ReglasNegocioPlazo } from '../_models/reglas-negocio-plazo';

@Injectable({
  providedIn: 'root'
})
export class ReglasNegocioPlazoService {
  private masterService = AppSettings.rutServiciosAPL + '/api/reglasNegociosPlazos';

  constructor(private authHttp: HttpClient, private autServicio: AutenticacionService) { }

  getAll() {
    return this.authHttp.get( this.masterService )
      .pipe( map( res => res as ReglasNegocioPlazo[] ) );
  }

  getById(idReglaNegocioPlazo: string) {
    return this.authHttp.get( `${this.masterService}/${idReglaNegocioPlazo}` )
      .pipe( map( res => res as ReglasNegocioPlazo ) );
  }

  getAllEnabled() {
    return this.authHttp.get( `${this.masterService }/enabled`)
      .pipe( map( res => res as ReglasNegocioPlazo[] ) );
  }

  add(f: ReglasNegocioPlazo) {
    f.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.authHttp.post( this.masterService, f )
      .pipe( map( res => res as ReglasNegocioPlazo ) );
  }

  update(f: ReglasNegocioPlazo) {
    f.auditoriaUsuario = this.autServicio.obtenerIdUsuarioLogueado();
    return this.authHttp.put( this.masterService, f )
      .pipe( map( res => res as ReglasNegocioPlazo ) );
  }
}
